<template>
	<div>
		<header-pago />
		<section-success :full-name="fullName" />
		<section-payment v-if="!isPeru"/>
		<new-footer gray />
	</div>
</template>
<script>
import headerPago from '@/components/pago/app-header';
import newFooter from '@/components/home/new-footer';
import sectionSuccess from '@/components/generate-app/section-success';
import status from '@/components/pago/status';
import sectionPayment from '@/components/generate-app/section-payment';

export default {
	name: 'page-pago-exitoso',
	components: {
		headerPago,
		newFooter,
		sectionSuccess,
		status,
		sectionPayment,
	},
	props: {
		fullName: String,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-success-inscription.vue